import {useHalStates} from '@synako/haligator';
import {useClient} from '@/haligator-factory';
import {CatalogueMarketplace} from 'api-types/ffconnect';
import {LigneDePanierDesc} from 'api-types/ffconnect-hal';
import {State} from '@synako/halitrek';

export const useMarketplaceLigneDePanier = (
  marketplace_id: CatalogueMarketplace | undefined,
  code_article: string,
): State<LigneDePanierDesc> | undefined => {
  const client = useClient();

  const {states: panierStates} = useHalStates(
    marketplace_id
      ? client
          .follow('paniers', {type_panier: marketplace_id, statut: 'ouvert'})
          .followAll('items')
      : undefined,
  );
  const panierState = panierStates?.[0];

  const {states: lignesDePanier} = useHalStates(
    panierState?.followAll('lignes_de_panier'),
  );

  return lignesDePanier?.find((l) => l.data.code_article === code_article);
};
